import { render, staticRenderFns } from "./TodayButton.vue?vue&type=template&id=97beef16&scoped=true&"
import script from "./TodayButton.vue?vue&type=script&lang=js&"
export * from "./TodayButton.vue?vue&type=script&lang=js&"
import style0 from "./TodayButton.vue?vue&type=style&index=0&id=97beef16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97beef16",
  null
  
)

export default component.exports